{
  "maximum": "Daugiausia",
  "minimum": "Mažiausia"
}
